
import React from 'react';
import ReactDOM from 'react-dom';
import GlobalMessages from '/home/circleci/app/components/GlobalMessages';

const element = typeof document !== 'undefined' && document.querySelector('#GlobalMessages');

if (element) {
    const props = window.initialData['GlobalMessages'];

    ReactDOM.render(
        <GlobalMessages {...props}/>,
        element
    );
}

export default GlobalMessages;
